export default __webpack_public_path__ + "static/media/NIAS0270.34I106399_-16863_0.99c869e1.jpg";